


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'app-loading-bar',
})
export default class AppLoadingBar extends Vue {
  progress: number = 0
  animInterval: number = 0

  @Prop({ default: false })
  isLoading: boolean

  // watch prop change to animate into visible position
  @Watch('isLoading')
  onPropertyChanged(value: boolean, oldValue: boolean, deep: true) {
    // clear any ongoing animation
    clearInterval(this.animInterval);

    if (value) {
      // start load animation
      this.progress = 0;
      this.animInterval = setInterval(this.animateProgress, 80);
    } else {
      // finish load animation
      this.progress = 100;
    }
  }

  animateProgress() {
    // don't allow progress to reach total
    if (this.progress < 90) {
      this.progress += 3;
    }
  }

  // show/hide loader
  get show() {
    return this.progress < 100 && this.progress > 0;
  }
}
